import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { Row } from '@tanstack/react-table'
import _ from 'lodash'
import { ReactNode } from 'react'

import { SelectOption } from 'components/Select'
import { UserWorkspaceRole, userWorkspaceRoles } from 'features/user/types/userWorkspaceRole'
import { useAbility } from 'providers/casl'
import { useUpdatePublisher } from '../hooks/useUpdatePublisher'
import { PublisherForTable } from '../types'

export const UserRoleCell = ({ getParentRow, original }: Row<PublisherForTable>): ReactNode => {
  const ability = useAbility()
  const { id: workspaceId, role } = original
  const { email, id: userId } = { ...getParentRow()?.original }
  const { update } = useUpdatePublisher({ email })

  const show = role && workspaceId && userId

  if (!show) return null

  const canManage: boolean =
    ability.can('update', 'Publisher') && ability.can('delete', 'Publisher')

  const options: SelectOption<UserWorkspaceRole>[] = userWorkspaceRoles.map(
    (role: UserWorkspaceRole): SelectOption<UserWorkspaceRole> => ({
      label: _.startCase(role),
      value: role,
    }),
  )

  const handleChange = (event: SelectChangeEvent<UserWorkspaceRole>): void =>
    void update({ role: event.target.value as UserWorkspaceRole, userId, workspaceId })

  return (
    <Select
      disabled={!canManage}
      onChange={handleChange}
      size='small'
      value={role}
      variant='standard'
    >
      {options.map(
        (option: SelectOption<UserWorkspaceRole>): React.JSX.Element => (
          <MenuItem
            key={option.value}
            value={option.value}
          >
            {option.label}
          </MenuItem>
        ),
      )}
    </Select>
  )
}
